// Package Imports
import { toJS } from "mobx";

// Project Imports
import isObjectEmpty from "utils/isObjectEmpty";
import AuthStore from "../../login/store/AuthStore";
import OptimizationStore from "../store/OptimizationStore";
import * as APITypes from "constants/API";
import axios from "../../../utils/axios";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";
import SolutionStore from "modules/solution/store/SolutionStore";

const updateProductwiseRiskData = (result) => {
  let changeProductReqList = [];
  let proposerIdList = [];
  let productListData = toJS(OptimizationStore.product_list_data);
  let needMaster = AuthStore.needMasterList
  let needId = needMaster.find(
    (item) => item?.unique_name === result?.data[0]?.need_unique_name)?.id;
  
  if (result?.status?.toString()?.toLowerCase() === "success") {
    const { family_product_details_list: totalFamilyProductsList, journey_need: JourneyNeed } = toJS(
      AuthStore.journeyData
    );
    let productRiskData = {};
    if (Array.isArray(result.data[0].data[0].BI)) {
      // productRiskData = result[0].data[0].BI[0];
      productRiskData = result.data[0].data[0].BI[0];
    } else {
      // productRiskData = result[0].data[0];
      productRiskData = result.data[0].data[0];
    }

    productListData.map((item) => {
      item.data.forEach(async (value) => {

        value.proposer_details = Object.keys(value?.proposer_details).length !== 0
          ? value.proposer_details
          : result.data[0].data[0]?.proposer_details || {};
        proposerIdList.push(value?.proposer_details?.id);
        if (!Array.isArray(value.BI)) {
          // For single products
          if (
            item.need_unique_name === result.data[0].need_unique_name &&
            value.family_product_id === productRiskData.family_product_id
          ) {

            const needId = needMaster.find((data) => data?.unique_name === item.need_unique_name)?.id;
            const selectedProductRisk = JourneyNeed.find((items)=> items?.need === needId)?.risk_type
            
            value.selectedRisk = selectedProductRisk ? selectedProductRisk : productRiskData.selectedRisk
              ? productRiskData.selectedRisk
              : "high";
            value.selected_risk_type = selectedProductRisk ? selectedProductRisk : productRiskData.selected_risk_type
              ? productRiskData.selected_risk_type
              : productRiskData.selected_risk_type;
            value.update_BI = true;
            if (isObjectEmpty(productRiskData.BI)) return;
            if (
              productRiskData.BI.JsonOutput == "" ||
              !productRiskData.BI.JsonOutput
            ) {
              return;
            }
            let jsonOutputData = JSON.parse(productRiskData.BI.JsonOutput);
            let inputValidationStatus = [];
            if (jsonOutputData?.InputValidationStatus !== null) {
              inputValidationStatus =
                jsonOutputData.InputValidationStatus.filter(
                  (item, index) => index !== 0
                );
            } else {
              inputValidationStatus.push(jsonOutputData);
            }

            OptimizationStore.isLoading = false;
            let biData2 = [];
            if (
              jsonOutputData &&
              jsonOutputData.hasOwnProperty("BIJson2") &&
              jsonOutputData?.BIJson2
            ) {
              biData2 = JSON.parse(jsonOutputData.BIJson2);
            } else {
              biData2 = JSON.parse(jsonOutputData.BIJson);
            }
            value.bi_request = productRiskData.bi_request;
            value.BI = productRiskData.BI;
            value.biResponseCompleteData = biData2;
            value.firstYearResponse = biData2 ? biData2[0] : {};
            value.parsedResponse = biData2 ? biData2[biData2.length - 1] : {};
            value.parsedResponse.inputValidationStatus = inputValidationStatus;
            value.isErrorExist = biData2 ? false : true;
            value.errorMessage = biData2
              ? ""
              : OptimizationStore.fetchErrorMsg(jsonOutputData);

            value.selectedPrice = OptimizationStore.fetchProductPrice(
              productRiskData.product_name,
              value.firstYearResponse,
              value.parsedResponse,
              value
            );
            value.quotationId = jsonOutputData.QuotationId;
            value.parsedResponse.productValidationData =
              jsonOutputData.InputValidationStatus
                ? jsonOutputData.InputValidationStatus[0]
                : [];
            const productData = totalFamilyProductsList.find(
              (product) => product.id === productRiskData.family_product_id
            );
            value.isDisabledNeed = value.isSelected && item.is_removed;
            value.productDisabled = productData?.la_removed || false;
            value.isValidationExist = biData2 ? false : true;
            value.changeProductList = value.changeProductList || [];
            value.fieldChanged = false;
            value.update_BI = true;
            value.covid_vaccination_status =
              productRiskData.covid_vaccination_status;
            value.maximum_sum_assured = productRiskData.maximum_sum_assured;
            value.minimum_sum_assured = productRiskData.minimum_sum_assured;
            value.premium_message = productRiskData?.premium_message;

            value.premium_message = productRiskData?.premium_message;
            value.package_id = productRiskData.package_id;
            value.product_id = productRiskData.product_id;
            value.product_name = productRiskData.product_name;
            value.recommended_sum_assured =
              productRiskData.recommended_sum_assured;
            value.selected_sum_Assured = productRiskData.selected_sum_Assured;
            value.target_sa_more_than_reco_sa =
              productRiskData.target_sa_more_than_reco_sa;
            value.family_product_id = productRiskData.family_product_id;
            value.nudge_message = productRiskData.nudge_message;
            value.irr_value = productRiskData?.irr
            value.bi_table_premium_click = false;
            changeProductReqList.push({
              family_product_id: value.family_product_id,
              risk: "high",
              user_journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
              target_amount: value.selected_sum_Assured,
              recommended_cover: value.recommended_sum_assured,
              current_product_id: value.product_id,
              current_package_id: value.package_id,
            });
            await axios.post(`${APITypes.SAVE_RISK_TYPE}`, {
              family_product_id: productRiskData.family_product_id,
              risk_type: value.selectedRisk,
            });
          }
        } else {
          // For multiple products to show in a tabupdateProductwiseRiskData
          value.BI.forEach( async (productDetails) => {
            const needId = needMaster.find((data) => data?.unique_name === item.need_unique_name)?.id;
            const selectedProductRisk = JourneyNeed.find((items)=> items?.need === needId)?.risk_type

            value.selectedRisk = selectedProductRisk ? selectedProductRisk : value.selectedRisk
              ? value.selectedRisk
              : productRiskData.risk;
            value.selected_risk_type = selectedProductRisk ? selectedProductRisk :  value.selected_risk_type
              ? value.selected_risk_type
              : productRiskData.risk;
            if (
              item.need_unique_name === result.data[0].need_unique_name &&
              value.family_product_id === productRiskData.family_product_id &&
              productRiskData.risk === productDetails.risk
            ) {
              productDetails.update_BI = true;
              if (Object.keys(productRiskData.BI).length == 0) {
                productDetails.parsedResponse = {};
              } else {
                if (isObjectEmpty(productRiskData.BI)) return;

                if (
                  productRiskData.BI.JsonOutput == "" ||
                  !productRiskData.BI.JsonOutput
                ) {
                  return;
                }
                let jsonOutputData = JSON.parse(productRiskData.BI.JsonOutput);
                let inputValidationStatus = [];
                if (jsonOutputData?.InputValidationStatus !== null) {
                  inputValidationStatus =
                    jsonOutputData.InputValidationStatus.filter(
                      (item, index) => index !== 0
                    );
                } else {
                  inputValidationStatus.push(jsonOutputData);
                }
                // OptimizationStore.isLoading = false;
                let biData2 = [];
                if (
                  jsonOutputData &&
                  jsonOutputData.hasOwnProperty("BIJson2") &&
                  jsonOutputData?.BIJson2
                ) {
                  biData2 = JSON.parse(jsonOutputData.BIJson2);
                } else {
                  biData2 = JSON.parse(jsonOutputData.BIJson);
                }
                productDetails.bi_request = productRiskData.bi_request;
                productDetails.BI = productRiskData.BI;
                productDetails.firstYearResponse = biData2 ? biData2[0] : {};
                productDetails.parsedResponse = biData2
                  ? biData2[biData2.length - 1]
                  : {};
                productDetails.parsedResponse.inputValidationStatus =
                  inputValidationStatus;
                productDetails.biResponseCompleteData = biData2;
                productDetails.isErrorExist = biData2 ? false : true;
                productDetails.errorMessage = biData2
                  ? ""
                  : OptimizationStore.fetchErrorMsg(jsonOutputData);
                productDetails.investment_target =
                  productDetails.bi_request.investment_target;
                productDetails.totalPrice = OptimizationStore.fetchProductPrice(
                  productDetails.product_name,
                  productDetails.firstYearResponse,
                  productDetails.bi_request,
                  productDetails
                );
                productDetails.quotationId = jsonOutputData.QuotationId;
                productDetails.parsedResponse.productValidationData =
                  jsonOutputData.InputValidationStatus
                    ? jsonOutputData.InputValidationStatus[0]
                    : [];
                const productData = totalFamilyProductsList.find(
                  (product) => product.id === productRiskData.family_product_id
                );
                value.isDisabledNeed = value.isSelected && item.is_removed;
                value.productDisabled = productData?.la_removed || false;
                productDetails.isValidationExist = biData2 ? false : true;
                productDetails.changeProductList =
                  productDetails.changeProductList || [];
                productDetails.fieldChanged = false;
                productDetails.update_BI = true;
                productDetails.covid_vaccination_status =
                  productRiskData.covid_vaccination_status;
                productDetails.maximum_sum_assured =
                  productRiskData.maximum_sum_assured;
                productDetails.minimum_sum_assured =
                  productRiskData.minimum_sum_assured;
                productDetails.premium_message =
                  productRiskData?.premium_message;
                productDetails.package_id = productRiskData.package_id;
                productDetails.product_id = productRiskData.product_id;
                productDetails.product_name = productRiskData.product_name;
                productDetails.recommended_sum_assured =
                  productRiskData.recommended_sum_assured;
                productDetails.selected_sum_Assured =
                  productRiskData.selected_sum_Assured;
                productDetails.target_sa_more_than_reco_sa =
                  productRiskData.target_sa_more_than_reco_sa;
                productDetails.family_product_id =
                  productRiskData.family_product_id;
                productDetails.nudge_message = productRiskData.nudge_message;
                productDetails.irr_value = productRiskData?.irr
                productDetails.bi_table_premium_click = false;
                changeProductReqList.push({
                  family_product_id: productDetails.family_product_id,
                  risk: productDetails.risk,
                  user_journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
                  target_amount: productDetails.selected_sum_Assured,
                  recommended_cover: productDetails.recommended_sum_assured,
                  current_product_id: productDetails.product_id,
                  current_package_id: productDetails.package_id,
                });
              }
              if (productRiskData.risk == value.selected_risk_type) {

                await axios.post(`${APITypes.SAVE_RISK_TYPE}`, {
                  family_product_id: productRiskData.family_product_id,
                  risk_type: value.selectedRisk,
                });
                value.selectedPrice = OptimizationStore.fetchProductPrice(
                  productDetails.product_name,
                  productDetails.firstYearResponse,
                  productDetails.parsedResponse,
                  productDetails
                );
                value.selectedInvestmentTarget =
                  productDetails.bi_request.investment_target;
              }
            }
          });
        }

        let reqObj = OptimizationStore.createReqObjCampaign(value)
         OptimizationStore.saveCampaignData(reqObj)
  
      });
      return item;
    });
    proposerIdList = [...new Set(proposerIdList)];

    SolutionStore.setProposerList(proposerIdList);
    OptimizationStore.changeProductOnPageLoad(changeProductReqList);
  }
  OptimizationStore.product_list_data = [...productListData];
};

export default updateProductwiseRiskData;
